let obj = {
  // state 物流状态：0、正在派送；10、已完成
  stateData: [
    { label: '正在派送', value: 0 },
    { label: '已完成', value: 10 },
  ],
}
export default obj
